
import MxInfoButton from '@/components/global/MxInfoButton.vue';
import FeedbackForm from './FeedbackForm.vue';
import MxModal from '@/components/global/MxModal.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { EvaStatus, FeedbackType, IMedexInsight, MediaType, MedexInsightType, IPathEvaluationResult, ProvenanceCategoryIcons } from '@/types/resource.types';
import fileService from '@/services/ProjectFileService';

@Component({
    name: 'InsightsCard',
    components: {
        MxInfoButton,
        MxModal,
        FeedbackForm
    }
})
export default class InsightsCard extends Vue {

    /* Props
    ============================================*/
    @Prop({type: Array, required: true})
    readonly insights: IMedexInsight[];

    @Prop({type: Boolean, required: true})
    readonly showFeedbackForm: boolean = true;

    @Prop({type: Number, required: true})
    readonly projectFileId: number;

    @Prop({type: Number, required: false})
    readonly mediaType?: MediaType;

    @Prop({type: Number, required: false, default: EvaStatus.NotRequested})
    readonly evaStatus: EvaStatus;

    @Prop({type: Boolean, required: false, default: false})
    readonly useEva: boolean;

    @Prop({type: Boolean, required: false, default: false})
    readonly indicatorsOnly: boolean;

    /* Computed
    ============================================*/

    get isDocument(): boolean {
        return this.mediaType === MediaType.Document;
    }

    get provenanceIcon(): string {
        const category = this.getEvaInsight?.evaProvenanceCategory;
        if (!category) return 'mdi-help-circle-outline';
        return ProvenanceCategoryIcons[category] ?? 'mdi-help-circle-outline';
    }

    /* Data
    ============================================*/
    structuralIdentifiers: String = "None";
    feedbackType : FeedbackType = FeedbackType.MedexInsights;
    showModal: boolean = false;
    analysis: IPathEvaluationResult | undefined = undefined;
    /* Methods
    ============================================*/
    getDescription(type: MedexInsightType){
        switch(type){
            case MedexInsightType.BRAND_INDICATOR:
                return "Brand Indicator";
            case MedexInsightType.DEVICE_INDICATOR:
                return "Device Indicator";
            case MedexInsightType.LAST_GENERATION_INDICATOR:
                return "Last Generation Indicator";
            case MedexInsightType.NOT_ORIGINAL_DEVICE_INDICATOR:
                return "Camera Original Indicator";
            case MedexInsightType.AUTOMATED_INSIGHT:
                return "Automated Insight";

        }
    }
    getPassFail(value : boolean | undefined){
        if(value === true) return "Pass";
        return "Fail"
    }
    get indicators(){
        if (!this.indicatorsOnly && (this.evaRunning || this.getEvaInsight)) return [];
        return this.insights.filter((x) =>
            x.insightType != MedexInsightType.AUTOMATED_INSIGHT &&
            x.insightType != MedexInsightType.EVA_ANALYSIS
        );
    }
    get evaRunning(): boolean {
        return this.evaStatus === EvaStatus.Pending || this.evaStatus === EvaStatus.Running;
    }

    get showInsights(){
        if (this.indicatorsOnly) {
            return this.insights?.some(x =>
                x.insightType != MedexInsightType.AUTOMATED_INSIGHT &&
                x.insightType != MedexInsightType.EVA_ANALYSIS
            ) ?? false;
        }
        return this.evaRunning || (this.insights && this.insights.length > 0);
    }
    get getAutomatedInsight(){
        if(!this.showInsights) return undefined;
        return this.insights.find(x => x.insightType == MedexInsightType.AUTOMATED_INSIGHT);
    }
    get getEvaInsight(){
        if(!this.showInsights) return undefined;
        return this.insights.find(x => x.insightType == MedexInsightType.EVA_ANALYSIS && x.evaFinalSummary);
    }
    async loadAnalysis(){
        try{
            if(!this.analysis){
                this.$loading = true;
                this.analysis = await fileService.getAutomatedAnalysis(this.projectFileId);
            }
            this.showModal = true;
        } 
        catch(e) {
            this.$logger.logError(e);
        } finally {
            this.$loading = false;
        }
    }
}

